import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const API = process.env.REACT_APP_API_URL || "http://localhost:4000";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("無效的驗證連結");
      return;
    }

    fetch(`${API}/api/auth/verify-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.message) {
          setStatus("success");
        } else {
          setStatus("error");
          setMessage(data.error || "驗證失敗");
        }
      })
      .catch(() => {
        setStatus("error");
        setMessage("網路錯誤，請稍後再試");
      });
  }, [searchParams]);

  return (
    <div style={{
      minHeight: "calc(100vh - 60px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 24,
    }}>
      <div className="card fade-up" style={{ width: "100%", maxWidth: 420, padding: 48, textAlign: "center" }}>

        {status === "verifying" && (
          <>
            <div className="spinner" style={{ margin: "0 auto 24px" }} />
            <p style={{ color: "var(--muted)" }}>驗證中...</p>
          </>
        )}

        {status === "success" && (
          <>
            <div style={{ fontSize: 56, marginBottom: 24 }}>✅</div>
            <h1 style={{ fontSize: 28, marginBottom: 12 }}>驗證成功！</h1>
            <p style={{ color: "var(--muted)", marginBottom: 32 }}>
              你的 Email 已驗證，現在可以登入了。
            </p>
            <button
              className="btn btn-primary btn-full"
              style={{ height: 48 }}
              onClick={() => navigate("/login")}
            >
              前往登入
            </button>
          </>
        )}

        {status === "error" && (
          <>
            <div style={{ fontSize: 56, marginBottom: 24 }}>❌</div>
            <h1 style={{ fontSize: 28, marginBottom: 12 }}>驗證失敗</h1>
            <p style={{ color: "var(--muted)", marginBottom: 32 }}>{message}</p>
            <button
              className="btn btn-outline btn-full"
              style={{ height: 48 }}
              onClick={() => navigate("/register")}
            >
              重新註冊
            </button>
          </>
        )}

      </div>
    </div>
  );
}
